import React from 'react';

import { EUR, USD } from '@/config/appConstants';
import { Currency } from '@/types';

export type CurrencySwitchType = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: Currency;
  className?: string;
  title?: string;
};

export const CurrencySwitch = ({
  onChange,
  defaultValue = EUR,
  className = '',
  title,
}: CurrencySwitchType) => {
  const getSwitchStyle = () =>
    'appearance-none rounded-full h-8 w-8 bg-white bg-md-purple border-md-purple opacity-20 checked:opacity-100 focus:outline-none transition duration-200 my-1 align-top bg-no-repeat bg-center bg-contain float-left cursor-pointer';
  const getSwitchLabelStyle = () =>
    'absolute font-bold text-white text-xl inline-block top-[5px] cursor-pointer';

  return (
    <div className="w-[200px] m-auto flex flex-wrap">
      {title && <span className="text-sm ml-4 font-black">{title}</span>}
      <div className={`${className} flex justify-center gap-2`}>
        <div className="relative">
          <input
            className={getSwitchStyle()}
            onChange={onChange}
            type="radio"
            name="currencySwitch"
            id="currencySwitchEuro"
            defaultChecked={defaultValue === EUR}
            value={EUR}
          />
          <label className={`${getSwitchLabelStyle()} left-[9px]`} htmlFor="currencySwitchEuro">
            €
          </label>
        </div>
        <div className="relative">
          <input
            className={getSwitchStyle()}
            onChange={onChange}
            type="radio"
            name="currencySwitch"
            id="currencySwitchDollar"
            defaultChecked={defaultValue === USD}
            value={USD}
          />
          <label className={`${getSwitchLabelStyle()} left-[10px]`} htmlFor="currencySwitchDollar">
            $
          </label>
        </div>
      </div>
    </div>
  );
};
